module.exports = __webpack_public_path__ + "img/img_nav_vip.2a46f51b.svg";